import { Injectable } from '@angular/core';
import {ScrollHelper} from './scroll-helper';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  private lastScrollPositionBeforeStepChange: number;

  constructor() { }

  updateScrollPositionBeforeStepChange(): void {
    this.lastScrollPositionBeforeStepChange = window.scrollY;
  }

  restoreScrollPositionAfterStepChange(): void {
    this.scrollToY(this.lastScrollPositionBeforeStepChange);
  }

  scrollToY(y: number): void {
    window.scrollTo(0, y);
  }

  scrollToTop(): void {
    (new ScrollHelper()).scrollToTop();
  }

  scrollToView(selector: string, timeout?: number): void {
    if (timeout) {
      setTimeout(() => (new ScrollHelper()).scrollIntoView(selector, {behavior: 'smooth'}), timeout);
    } else {
      (new ScrollHelper()).scrollIntoView(selector, {behavior: 'smooth'});
    }

  }
}
